import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { withTranslation } from 'react-i18next';
import i18n from '../../helpers/i18n';

import { withStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import DashboardIcon from '@material-ui/icons/Dashboard';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import PeopleIcon from '@material-ui/icons/People';
import SettingsInputAntennaIcon from '@material-ui/icons/SettingsInputAntenna';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import ShowChart from '@material-ui/icons/ShowChart';
import BarChart from '@material-ui/icons/BarChart';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import BrokenImage from '@material-ui/icons/BrokenImage';
import TimelineIcon from '@material-ui/icons/Timeline';
import ArrowForward from '@material-ui/icons/ArrowForward';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import AppBrand from '../../common-components/AppBrand';
import DeveloperBoardIcon from '@material-ui/icons/DeveloperBoard';
import DvrRoundedIcon from '@material-ui/icons/DvrRounded';
import ReportRoundedIcon from '@material-ui/icons/ReportRounded';
// Assets
import AIBrainIco from '../../assets/icons/ai-brain.png';
import ForecastingIco from '../../assets/icons/forecastIcon.png';

import * as mainSideBarReducers from '../reducer';

import * as mainSideBarActions from '../action-creator';

import * as strings from '../../helpers/strings';
import ThemeColors from '../../common-components/ThemeColors';
// import WeatherCard from '../../common-components/WeatherCard';
import Tooltip from '@material-ui/core/Tooltip';

import * as systemActionMgr from '../../system/action-creator';

import * as mqttMgr from '../../helpers/MqttMgr';

// Create menu map function that uses translations
const createMenuMap = (t) => ({
  "/dashboard": { path: "/dashboard", name: t("dashboard"), icon: <DashboardIcon />, translationKey: "dashboard" },
  "/users": { path: "/users", name: t("users"), icon: <PeopleIcon />, translationKey: "users" },
  "/stations": { path: "/stations", name: t("stations"), icon: <SettingsInputAntennaIcon />, translationKey: "stations" },
  "/station-history": { path: "/station-history", name: t("historical-records"), icon: <ShowChart />, translationKey: "historical-records" },
  "/station-fastdata": { path: "/station-fastdata", name: t("station-realtime-data"), icon: <TimelineIcon />, translationKey: "station-realtime-data" },
  "/station-statistics": { path: "/station-statistics", name: t("station-statistics"), icon: <BarChart />, translationKey: "station-statistics" },
  "/station-forecast-data": { path: "/station-forecast-data", name: t("forecasting"), icon: <img src={ForecastingIco} alt="ForecastingIco" />, translationKey: "forecasting" },
  "/system-device-faults": { path: "/system-device-faults", name: t("system-fault"), icon: <DeveloperBoardIcon />, translationKey: "system-fault" },
  "/portfolio-fault-overview": { path: "/portfolio-fault-overview", name: t("portfolio-fault-overview"), icon: <ReportRoundedIcon />, translationKey: "portfolio-fault-overview" },
  "/stations-health": { path: "/stations-health", name: t("station-health"), icon: <LocalHospitalIcon />, translationKey: "station-health" },
  "/download": { path: "/download", name: t("download"), icon: <CloudDownloadIcon />, translationKey: "download" },
  "/error-reports": { path: "/error-reports", name: t("errors-reports"), icon: <ReportProblemIcon />, translationKey: "errors-reports" }
})

const drawerWidth = 280;

const styles = theme => ({
  userEmail: {
    margin: 0,
    position: "absolute",
    bottom: 12,
    color: "#fff",
    fontSize: 14
  },
  userEmailLink: {
    textDecoration: "none",
    color: "#fff"
  },
  drawerPaper: {
    width: drawerWidth,
    background: ThemeColors.sideBar,
    paddingTop: 64,
    [theme.breakpoints.down('md')]: {
      paddingTop: 0
    },
    [theme.breakpoints.up('lg')]: {
      position: 'fixed',
      height: 'calc(100% - 64px)',
    },
  },
  menuText: {
    color: "rgba(255, 255, 255, 1)",
    fontSize: "1em"
  },
  menuIcon: {
    color: "rgba(255, 255, 255, 1)",
    fontSize: "1.5em",
    margin: "0px 9px !important"
  },
  selectedItem: {
    transform: "scale(1.1)",
    transformOrigin: "top center",
    transition: "all .2s ease-in-out",
    background: "rgba(178, 177, 185, 0.3)",
  },
  listItemHover: {
    '&:hover': {
      transform: "scale(1.1)",
      transformOrigin: "top center",
      transition: "all .2s ease-in-out",
      background: "rgba(178, 177, 185, 0.3)",
    }
  },
  list: {
    paddingTop: 75,
    [theme.breakpoints.down('md')]: {
      paddingTop: 0
    }
  },
  nested: {
    paddingLeft: theme.spacing.unit * 4,
  },

  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing.unit * 7 + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9 + 1,
    },
  },
});

let tokenExpireTime = null
let lastInactiveTime = null

let tokenInterval;

class AppSideBar extends Component {
  constructor(props) {
    super(props);
    this.goto = this.goto.bind(this);
    this.handleDrawerToggle = this.handleDrawerToggle.bind(this);
    this.tokenChecker = this.tokenChecker.bind(this)
    this.fn_blur = this.fn_blur.bind(this)
  }



  componentDidMount() {

    const { refreshToken } = this.props

    this.tokenChecker();
    refreshToken();

    //Browser Active
    window.addEventListener('focus', this.fn_focus);

    // Browser Inactive
    window.addEventListener('blur', this.fn_blur);

    // Listen for language changes to force re-render
    this.i18nLanguageChangedHandler = () => {
      this.forceUpdate();
    };
    i18n.on('languageChanged', this.i18nLanguageChangedHandler);
  }

  componentWillUnmount() {
    // console.log("REMOVE BLUR/FOCUS")
    window.removeEventListener('blur', this.fn_blur);
    window.removeEventListener('focus', this.fn_focus);
    
    // Remove i18n language change listener
    if (this.i18nLanguageChangedHandler) {
      i18n.off('languageChanged', this.i18nLanguageChangedHandler);
    }
  }

  tokenChecker() {
    const { refreshToken, logout, getValidToken } = this.props

    clearInterval(tokenInterval);
    // Every 25 min check token
    tokenInterval = setInterval(function () {
      if (localStorage.getItem("_token") === "") {
        mqttMgr.disconnect()
        clearInterval(tokenInterval);
      } else {
        let date = new Date()
        Date.parse(date)

        if ((tokenExpireTime < Date.parse(date)) && lastInactiveTime === null) {
          refreshToken()
          let date = new Date()
          tokenExpireTime = Date.parse(date) + (1500 * 1000)   // Add 25 mins and extend tokenExpireTime
        } else if ((tokenExpireTime < Date.parse(date)) && lastInactiveTime !== null) {
          mqttMgr.disconnect()
          logout();
          clearInterval(tokenInterval);
        }
      }

      if (getValidToken === "Failed") {
        console.log("***********FAILED")
        mqttMgr.disconnect()
        clearInterval(tokenInterval);
        logout();
      }
    }, 3000); // 60 * 1000 milsec

  }


  fn_blur() {
    const { refreshToken } = this.props

    let date = new Date()
    let _token = localStorage.getItem("_token")

    if (_token === "") {
      window.removeEventListener('blur', this.fn_blur);
    }

    if (lastInactiveTime + 60000 > Date.parse(date) || lastInactiveTime === null) {
      //
      // lastInactiveTime is user last InActive Time. 
      // -- if User second time inactive time is more than 1 minutes of lastInactiveTime
      // -- System will call refresh token API | Update TokenExpireTime | lastInactiveTime
      //
      let date = new Date()
      if (tokenExpireTime > Date.parse(date) && _token !== "") {
        refreshToken()
        tokenExpireTime = Date.parse(date) + (1500 * 1000)
        lastInactiveTime = Date.parse(date)
      }
    }
  }


  fn_focus() {
    setTimeout(() => {
      lastInactiveTime = null
    }, 1000);
  }



  goto = (path) => {
    const { history, toggleMainSideBar, width, setSelectedPath } = this.props;
    history.push(path);
    setSelectedPath(path);
    if (!isWidthUp("lg", width))
      toggleMainSideBar();
  }
  handleDrawerToggle = () => {
    this.props.toggleMainSideBar();
  }
  render() {
    const { classes, opened, handleDrawerToggle, toggleMainSideBar, selectedPath, menuPaths, t } = this.props;

    // Use t from props if available, otherwise use i18n.t directly
    // This ensures we always have a working translation function
    const translate = t || i18n.t.bind(i18n);

    const menuMap = createMenuMap(translate);
    const menuItems = menuPaths.map(path => menuMap[path]);

    const drawer = (
      <div>
        <Hidden lgUp>
          <AppBrand />
        </Hidden>
        <List className={classes.list}>
          {menuItems.map(menuItem => {
            return menuItem ?
              (
                <ListItem className={`${selectedPath === menuItem.path ? classes.selectedItem : ''}  ${classes.listItemHover}`} key={menuItem.path} button onClick={e => this.goto(menuItem.path)} >
                  <Tooltip title={menuItem.name} placement="right"><ListItemIcon classes={{ root: classes.menuIcon }}>
                    {menuItem.icon}
                  </ListItemIcon>
                  </Tooltip>
                  <ListItemText primary={menuItem.name} classes={{ primary: classes.menuText }} />
                </ListItem>
              )
              :
              null
          })}
        </List>
      </div>
    );
    // const weatherCard = (
    //     <WeatherCard/>
    // );


    return (
      <div id="main-side-bar">
        <Hidden lgUp>
          <Drawer
            variant="temporary"
            anchor="left"
            open={opened}
            classes={{
              paper: classes.drawerPaper,
            }}
            onClose={() => this.handleDrawerToggle()}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >

            {drawer}
            <button className='toggleDrawer' onClick={this.handleDrawerToggle}>
              {opened ?  <ArrowBackIcon/> : <ArrowForward /> }
            </button>
            {/* {weatherCard} */}
          </Drawer>
        </Hidden>
        <Hidden mdDown >
          <Drawer
            variant="permanent"
            open={opened}
            className={classNames(classes.drawer, {
              [classes.drawerOpen]: opened,
              [classes.drawerClose]: !opened,
            })}
            classes={{
              paper: classNames({
                [classes.drawerOpen]: opened,
                [classes.drawerClose]: !opened,
              }),
            }}
          >
            
            {drawer}
            <button className='toggleDrawer' onClick={this.handleDrawerToggle}>
              {opened ? <ArrowBackIcon/> : <ArrowForward />}
            </button>
            {/* {weatherCard} */}
          </Drawer>
        </Hidden>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  opened: mainSideBarReducers.isOpened(state),
  selectedPath: mainSideBarReducers.getSelectedPath(state),
  menuPaths: mainSideBarReducers.getMenuPaths(state)
});


// Wrap with withTranslation first to ensure i18n props are available
const TranslatedSideBar = withTranslation()(AppSideBar);

export default connect(mapStateToProps, {
  refreshToken: systemActionMgr.refreshToken,
  logout: systemActionMgr.logout,
  toggleMainSideBar: mainSideBarActions.toggleMainSideBar,
  setSelectedPath: mainSideBarActions.setSelectedPath
})(withStyles(styles)(withRouter(withWidth()(TranslatedSideBar))))